import React from 'react';
import { motion } from 'framer-motion';
import { FaInstagram, FaWhatsapp, FaPhoneAlt } from 'react-icons/fa';
import trainerKarthikeyan from '../../assets/karthikeyan.png';
import trainerSanjay from '../../assets/trainer_sanjay.jpg';

const trainersData = [
  {
    name: 'Karthikeyan',
    role: 'Head Strength Trainer & Coach',
    speciality: 'Strength · Powerlifting · Progressive Overload',
    experience: '6+ Years',
    branch: 'Unit 1 Chettipalayam',
    image: trainerKarthikeyan,
    instagram: 'https://www.instagram.com/karthikeyan.dhinakaran?stkn=MXRjbzR4NTJjaXNxdA==',
    whatsapp: 'https://wa.me/919047477177',
    phone: '90474 77177',
  },
  {
    name: 'Sanjay',
    role: 'Gym Manager & Transformation Coach',
    speciality: 'Fitness Planning · Nutrition · Fat Loss Protocols',
    experience: '10+ Years',
    branch: 'Unit 2 Pappampatti',
    image: trainerSanjay,
    instagram: 'https://www.instagram.com/nsanjaykrish?stkn=a3h6aDk0amtnNmU1&utm_source=qr',
    whatsapp: 'https://wa.me/917339504861',
    phone: '73395 04861',
  },

];

const Trainers = () => {
  const transition = { type: 'spring', duration: 2.5 };

  const fadeUp = {
    hidden: { opacity: 0, y: 40 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: { ...transition, delay: i * 0.15 },
    }),
  };

  return (
    <section className="relative px-4 md:px-12 py-16 text-white overflow-hidden max-w-7xl mx-auto" id="trainers">
      <div className="absolute w-80 h-80 bg-red-600/15 blur-[160px] rounded-full top-0 right-10 -z-10" />

      {/* Header */}
      <motion.div
        className="text-center max-w-2xl mx-auto mb-16"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={transition}
        viewport={{ once: true }}
      >
        <span className="inline-block bg-red-600/15 border border-red-500/30 text-red-500 text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-3 shadow-lg">
          Meet the Team
        </span>
        <div className="text-3xl sm:text-5xl font-black uppercase tracking-wide mb-4">
          <span className="text-transparent [-webkit-text-stroke:_1.5px_white]">Our </span>
          <span className="text-red-500">Expert Trainers</span>
        </div>
        <p className="text-gray-300 text-xs sm:text-sm leading-relaxed">
          Certified coaches dedicated to your transformation journey across our 3 units in Coimbatore.
        </p>
      </motion.div>

      {/* Trainers Cards Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8">
        {trainersData.map((trainer, i) => (
          <motion.div
            key={i}
            className="group bg-gradient-to-b from-[#181a24]/90 to-[#12141c]/90 backdrop-blur-xl rounded-3xl border border-white/10 overflow-hidden shadow-2xl hover:border-red-500/50 transition-all duration-300 flex flex-col justify-between"
            custom={i}
            initial="hidden"
            whileInView="visible"
            variants={fadeUp}
            viewport={{ once: true, margin: '-40px' }}
            whileHover={{ y: -8 }}
          >
            {/* Image Container with Social Overlay */}
            <div className="relative h-80 overflow-hidden">
              <img
                src={trainer.image}
                alt={trainer.name}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#12141c] via-[#12141c]/30 to-transparent opacity-90 group-hover:opacity-95 transition-opacity" />

              {/* Branch Badge */}
              <div className="absolute top-4 left-4 z-10">
                <span className="bg-red-600 text-white text-[10px] font-black uppercase px-3 py-1 rounded-full shadow-md">
                  {trainer.branch}
                </span>
              </div>

              {/* Social Buttons */}
              <div className="absolute bottom-4 left-4 right-4 flex justify-center gap-3 translate-y-0 opacity-100 sm:translate-y-3 sm:opacity-0 sm:group-hover:opacity-100 sm:group-hover:translate-y-0 transition-all duration-300 z-10">
                <a
                  href={trainer.instagram}
                  target="_blank"
                  rel="noreferrer"
                  className="w-9 h-9 rounded-full bg-white/20 hover:bg-red-600 backdrop-blur-md flex items-center justify-center text-white text-sm transition-colors"
                  aria-label="Instagram"
                >
                  <FaInstagram />
                </a>
                <a
                  href={trainer.whatsapp}
                  target="_blank"
                  rel="noreferrer"
                  className="w-9 h-9 rounded-full bg-white/20 hover:bg-green-600 backdrop-blur-md flex items-center justify-center text-white text-sm transition-colors"
                  aria-label="WhatsApp"
                >
                  <FaWhatsapp />
                </a>
                <a
                  href={`tel:${trainer.phone.replace(/\s+/g, '')}`}
                  className="w-9 h-9 rounded-full bg-white/20 hover:bg-red-600 backdrop-blur-md flex items-center justify-center text-white text-sm transition-colors"
                  aria-label="Phone"
                >
                  <FaPhoneAlt />
                </a>
              </div>
            </div>

            {/* Trainer Details */}
            <div className="p-6 flex flex-col justify-between flex-grow">
              <div>
                <h3 className="text-xl font-black text-white mb-1 group-hover:text-red-400 transition-colors uppercase">
                  {trainer.name}
                </h3>
                <span className="text-xs uppercase tracking-wider text-red-500 font-bold block mb-2">
                  {trainer.role}
                </span>
                <p className="text-xs text-gray-300 block mb-4">
                  {trainer.speciality}
                </p>
              </div>

              <div className="flex flex-col gap-3 pt-4 border-t border-white/10">
                <a
                  href={trainer.whatsapp}
                  target="_blank"
                  rel="noreferrer"
                  className="w-full bg-white/5 hover:bg-red-600/80 border border-white/15 hover:border-red-500 text-white text-xs font-bold uppercase tracking-wider py-2.5 rounded-xl transition-all flex items-center justify-center gap-2 shadow-md"
                >
                  <FaWhatsapp className="text-green-400 text-sm" /> Talk to a Coach
                </a>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Trainers;

